import React, { useEffect, useState } from 'react';
import { Spin, Alert, Card } from 'antd';
import Layout from '../../components/Layout';
import AntTable from '../../components/CustomTable/AntTable';
import { customBaseUrl, httpGet } from '../../store/http';

const BillsPayment = () => {
  const [transactions, setTransactions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [pagination, setPagination] = useState({
    current: 0,
    pageSize: 10,
  });

  const fetchTransactions = async (params = {}) => {
    setLoading(true);
    try {
      const res = await httpGet(`${customBaseUrl.tranv2}/api/v1/admin/transactions/search?type=BILLS_PAYMENT`);
      if (res.data) {
        setTransactions(res.data);
        setPagination({
          ...params.pagination,
          total: res.data.length, 
        });
      } else {
        setError(res?.message || 'Failed to fetch transactions.');
      }
    } catch (err) {
      setError('An error occurred while fetching transactions.');
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchTransactions();
  }, []);

  const columns = [
    { title: 'Transaction ID', dataIndex: 'transactionId', key: 'transactionId' },
    { title: 'Biller Category', dataIndex: 'billerCategoryName', key: 'billerCategoryName' },
    { title: 'Biller Name', dataIndex: 'billerName', key: 'billerName' },
    { title: 'Amount', dataIndex: 'amount', key: 'amount' },
    { title: 'Status', dataIndex: 'status', key: 'status' },
    { title: 'Created At', dataIndex: 'createdAt', key: 'createdAt' },
    { title: 'Updated At', dataIndex: 'updatedAt', key: 'updatedAt' },
  ];

  return (
    <Layout>
      <Card title="Bills Payment Transactions">
        {loading ? (
          <Spin tip="Loading transactions..." />
        ) : error ? (
          <Alert message="Error" description={error} type="error" showIcon />
        ) : (
          <AntTable
            pagination={pagination}
            users={transactions}
            loading={loading}
            handleGetNext={fetchTransactions}
            columns={columns}
          />
        )}
      </Card>
    </Layout>
  );
};

export default BillsPayment;